// import Swiper core and required modules
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
// import Swiper bundle with all modules installed
import { Swiper, SwiperSlide } from "swiper/react";
// import styles bundle
import "swiper/css/bundle";
import { NavLink } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";

export default function DivisionsScroller() {
  return (
    <div className="mx-auto container ">
      <div className="flex">
        {/* <i className="text-7xl mt-2 mr-5 fi fi-br-angle-small-right text-[#06a7e0]"></i> */}
        <div className="logo-division-slider flex space-x-10 w-full">
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
            slidesPerView={5}
            direction={"horizontal"}
            loop={true}
            autoplay={true}
            breakpoints={{
              //Window width is >= 320px
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              //Window width is >= 480px
              480: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              //Window width is >= 640px
              640: {
                slidesPerView: 5,
                spaceBetween: 40,
              },
            }}
          >
            <SwiperSlide>
              <a
                href="https://statehouse.gov.sl/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  className="w-96 h-auto"
                  src="/images/governement-of-sierra-leone.svg"
                  alt=""
                />
              </a>
            </SwiperSlide>
            <SwiperSlide>
              <a href="https://www.dfc.gov/" rel="noreferrer" target="_blank">
                <img
                  className="w-60 h-auto"
                  src="/images/dfc-logo.svg"
                  alt=""
                />
              </a>
            </SwiperSlide>
            <SwiperSlide>
              <a
                href="https://www.anergigroup.com/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  className="w-40 h-auto"
                  src="/images/anergi-logo.svg"
                  alt=""
                />
              </a>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img
                  className="w-40 h-auto"
                  src="/images/tcq-logo.svg"
                  alt=""
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <a
                href="https://www.bidc-ebid.org/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  className="w-24 h-auto"
                  src="/images/ebid_logo.svg"
                  alt=""
                />
              </a>
            </SwiperSlide>
            <SwiperSlide>
              <a
                href="https://www.shapoorjipallonji.com/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  className="w-36 h-auto"
                  src="/images/shapoorji-pallonji-logo.svg"
                  alt=""
                />
              </a>
            </SwiperSlide>
            <SwiperSlide>
              <a
                href="https://www.siemens.com/global/en.html"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  className="w-40 h-auto"
                  src="/images/siemens-logo.svg"
                  alt=""
                />
              </a>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
}
